import React from "react";
//import {BrowserRouter as Router, Switch, Route, Link} from 'react-router-dom';
import Nav from "./nav";
import TicTacToe from "./TicTacToe"
function App() {
  return (
    <div>
      <Nav/>
      <TicTacToe/>
    </div>
  );
}
export default App;